import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["to", "isNavLink"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useMemo } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { isAbsolutePath } from "../util/isAbsolutePath";
import { RoutesContext } from "./RoutesWrapper";

// this type should be expanded to handle all the use cases available on the Link component

export function convertToLinkValue(routes, to) {
  if (!routes) return to;
  if (typeof to !== 'string') return to;
  var _to$split = to.split('?'),
    _to$split2 = _toArray(_to$split),
    path = _to$split2[0],
    queries = _to$split2.slice(1);
  var queryValue = queries.join('?');
  var _path$split = path.split('#'),
    _path$split2 = _toArray(_path$split),
    toValue = _path$split2[0],
    hashes = _path$split2.slice(1);
  var hashValue = hashes.join('#');
  var matchResult;
  var matchRoute = Object.keys(routes).map(function (key) {
    return routes[key];
  }).find(function (routeObj) {
    var _routeObj$match;
    matchResult = (_routeObj$match = routeObj.match) === null || _routeObj$match === void 0 ? void 0 : _routeObj$match.call(routeObj, toValue);
    return matchResult;
  });
  if (!matchRoute || !matchResult) {
    return to;
  }
  var convertedValue = matchRoute.toPath(matchResult.params);
  if (hashValue) convertedValue = "".concat(convertedValue, "#").concat(hashValue);
  if (queryValue) convertedValue = "".concat(convertedValue, "?").concat(queryValue);
  return convertedValue;
}
var ABLink = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var to = _ref.to,
    isNavLink = _ref.isNavLink,
    props = _objectWithoutProperties(_ref, _excluded);
  var routes = useContext(RoutesContext);
  var newTo = useMemo(function () {
    return convertToLinkValue(routes, to);
  }, [routes, to]);
  if (isAbsolutePath(newTo)) {
    return /*#__PURE__*/React.createElement("a", _extends({
      ref: ref,
      href: newTo
    }, props));
  }
  return isNavLink ? /*#__PURE__*/React.createElement(NavLink, _extends({
    ref: ref,
    to: newTo
  }, props)) : /*#__PURE__*/React.createElement(Link, _extends({
    ref: ref,
    to: newTo
  }, props));
});
export default ABLink;